import React from "react";
import { date, formatDate, formatDateTime } from "./util";
import { showDialog } from "../utility";
import WarningIcon from "@material-ui/icons/Warning";
import ImageIcon from "@material-ui/icons/Image";
import { env } from "../../env";
import { sortCaret, headerSortingClasses } from "../../_metronic/_helpers";
import moment from "moment";

export const prosesFormatter = (cellContent) => {
  if (cellContent === "W") {
    return "Waiting";
  } else if (cellContent === "R") {
    return "Reject";
  } else if (cellContent === "A") {
    return "Approve";
  } else if (cellContent === "K") {
    return "Confirm";
  }
};

export const PrintFormatter = (cellContent, row) => {
  let label = "";
  if (cellContent === "Y") {
    label = "Printed";
  } else if (cellContent === "N") {
    label = "Not Printed";
  } else if (cellContent === "NR") {
    label = "Not Printed Reupload";
  }

  return <span>{label}</span>;
};

export const activeFormatter = (cellContent, row) => {
  let label = "";
  if (cellContent === "Y") {
    label = "Active";
  } else if (cellContent === "N") {
    label = "Not Active";
  }

  let style = "";
  if (cellContent === "Y") {
    style = "success";
  } else if (cellContent === "N") {
    style = "danger";
  }

  return (
    <span
      className={`label label-lg label-${style} label-inline label-width-pending`}
    >
      {label}
    </span>
  );
};

export const statusInboundFormatter = (cellContent, row) => {
  let label = cellContent;

  let style = "";
  if (cellContent === "Canceled") {
    style = "danger";
  } else if (cellContent === "Initiated") {
    style = "danger";
  } else if (cellContent === "Confirmed") {
    style = "success";
  } else if (cellContent === "Completed") {
    style = "success";
  } else if (cellContent === "Unconfirmed") {
    style = "danger";
  } else if (cellContent === cellContent) {
    style = "success";
  }

  return <span className={`text-${style}`}>{label}</span>;
};

export const statusRfc = (cellContent, row) => {
  let label = "";
  if (cellContent === "P") {
    label = "Pending";
  } else if (cellContent === "D") {
    label = "Done";
  }

  let style = "";
  if (cellContent === "P") {
    style = "warning";
  } else if (cellContent === "D") {
    style = "success";
  }

  return (
    <span
      className={`label label-lg label-${style} label-inline label-width-pending`}
    >
      {label}
    </span>
  );
};

export const formatterStatus = (cellContent, row) => {
  let label = "";
  if (cellContent === "Y") {
    label = "Yes";
  } else if (cellContent === "N") {
    label = "No";
  } else if (cellContent === null) {
    label = "";
  } else {
    label = cellContent;
  }

  return <span>{label}</span>;
};

export const formatterHold = (cellContent, row) => {
  let label = "";
  if (cellContent === "Y") {
    label = "Hold";
  } else if (cellContent === "N") {
    label = "Un-hold";
  } else if (cellContent === null) {
    label = "";
  } else {
    label = cellContent;
  }

  return <span>{label}</span>;
};

export const StatusFormatter = (cellContent, row) => {
  let label = "";
  if (cellContent === "Y") {
    label = "Yes";
  } else if (cellContent === "N") {
    label = "No";
  } else if (cellContent === "Yes") {
    label = "Yes";
  } else if (cellContent === "No") {
    label = "No";
  } else {
    label = cellContent;
  }

  return <span>{label}</span>;
};

export const DateFormatter = (cellContent, row) => {
  let fmt_text = moment(cellContent).format("DD/MM/YYYY");
  return <span>{fmt_text}</span>
}

export const formatSend = (cellContent, row) => {
  let label = "";
  if (cellContent === true) {
    label = "SENT";
  } else if (cellContent === false) {
    label = "UNSENT";
  } else {
    label = cellContent;
  }

  return <span>{label}</span>;
};

export const lockedFormatter = (cellContent, row) => {
  let label = "";
  if (cellContent === "N") {
    label = "Unlock";
  } else if (cellContent === "Y") {
    label = "Lock";
  }

  let style = "";
  if (cellContent === "N") {
    style = "success";
  } else if (cellContent === "Y") {
    style = "danger";
  }

  return (
    <span
      className={`label label-lg label-${style} label-inline label-width-pending`}
    >
      {label}
    </span>
  );
};
export const statusReadFormatter = (cellContent, row) => {
  let label = "";
  if (cellContent === "Y") {
    label = "Read";
  } else if (cellContent === "N") {
    label = "Not Read";
  }

  let style = "";
  if (cellContent === "Y") {
    style = "success";
  } else if (cellContent === "N") {
    style = "info";
  }

  return (
    <span
      className={`label label-lg label-${style} label-inline label-width-pending`}
    >
      {label}
    </span>
  );
};

export const formatCurrency = (cellContent) => {
  return new Intl.NumberFormat("id-ID", {
    minimumFractionDigits: 2,
  }).format(cellContent);
};

export const formatUsd = (cellContent) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(cellContent);
};

export const numFormatter = (data) => {
  return parseFloat(data).toLocaleString(data, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const columnsCreateVehicle = [
  {
    text: "No",
    dataField: "no",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "60px" },
  },
  {
    text: "VIN",
    dataField: "vin",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "VON",
    dataField: "von",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Inbound Job",
    dataField: "inbound_job",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Master Code",
    dataField: "master_code_name",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Vehicle Name",
    dataField: "vehicle_name",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "UOM",
    dataField: "vehicle_uom",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Model Code",
    dataField: "model_code_name",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Model Name",
    dataField: "model_name",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Model Year",
    dataField: "model_year",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Color Code",
    dataField: "color_code_name",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Color Name",
    dataField: "color_name",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Production Date",
    dataField: "production_date",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    formatter: (e) => {
      if (e === null) {
        return "";
      }
      if (e === "") {
        return "";
      } else {
        return moment(e).format(date);
      }
    },

    style: { minWidth: "160px" },
  },
  {
    text: "Engine No.",
    dataField: "engine_no",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },

  {
    text: "Key No.",
    dataField: "key_no",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Mileage",
    dataField: "mileage",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Accessories Installed",
    dataField: "accessories_installed",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
    formatter: formatterStatus,
  },
  {
    text: "Accessories Installed Date ",
    dataField: "accessories_installed_date",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    formatter: (e) => {
      if (e === null) {
        return "";
      }
      if (e === "") {
        return "";
      } else {
        return moment(e).format(date);
      }
    },

    style: { minWidth: "160px" },
  },
  {
    text: "Location",
    dataField: "location",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Parent Location",
    dataField: "parent_location",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Hold Status",
    dataField: "hold_status",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
    formatter: formatterHold,
  },
  {
    text: "Hold Reason",
    dataField: "hold_reason",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Hold Remarks",
    dataField: "hold_reason_remarks",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "RCI Date",
    dataField: "rci_date",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    formatter: (e) => {
      if (e === null) {
        return "";
      }
      if (e === "") {
        return "";
      } else {
        return moment(e).format(date);
      }
    },

    style: { minWidth: "160px" },
  },
  {
    text: "RCI Inspection Result",
    dataField: "rci_inspection_result",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "RCI Remarks",
    dataField: "rci_remarks",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "PDI Date",
    dataField: "pdi_date",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    formatter: (e) => {
      if (e === null) {
        return "";
      }
      if (e === "") {
        return "";
      } else {
        return moment(e).format(date);
      }
    },

    style: { minWidth: "160px" },
  },
  {
    text: "PDI Results",
    dataField: "pdi_results",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "PDI Remarks",
    dataField: "pdi_remarks",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Maintenance Date",
    dataField: "maintenance_date",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    formatter: (e) => {
      if (e === null) {
        return "";
      }
      if (e === "") {
        return "";
      } else {
        return moment(e).format(date);
      }
    },
    style: { minWidth: "160px" },
  },
  {
    text: "Maintenance Hold Status",
    dataField: "maintenance_hold",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
    formatter: formatterHold,
  },
  {
    text: "Maintenance Hold Reason",
    dataField: "maintenance_hold_reason",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Maintenance Hold Remarks",
    dataField: "maintenance_hold_remarks",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Inspection Date",
    dataField: "inspection_date",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    formatter: (e) => {
      if (e === null) {
        return "";
      }
      if (e === "") {
        return "";
      } else {
        return moment(e).format(date);
      }
    },

    style: { minWidth: "160px" },
  },
  // {
  //   text: "Inspection Hold Status",
  //   dataField: "inspection_hold",
  //   sort: true,
  //   sortCaret: sortCaret,
  //   headerSortingClasses,
  //   style: { minWidth: "160px" },
  //   formatter: formatterHold,
  // },
  // {
  //   text: "Inspection Hold Reason",
  //   dataField: "inspection_hold_reason",
  //   sort: true,
  //   sortCaret: sortCaret,
  //   headerSortingClasses,
  //   style: { minWidth: "160px" },
  // },
  {
    text: "Inspection Remarks",
    dataField: "inspection_remarks",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Final Hold Status",
    dataField: "final_hold_status",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Vehicle Status",
    dataField: "vehicle_status_mpc",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "RFS",
    dataField: "rfs",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    formatter: formatterStatus,
  },
  {
    text: "Client",
    dataField: "client_name",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Inventory No.",
    dataField: "inventory_no",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
];

export const columnsCreateVehicleInv = [
  {
    text: "No",
    dataField: "no",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "60px" },
  },
  {
    text: "VIN",
    dataField: "vin",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "VON",
    dataField: "von",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Inbound Job",
    dataField: "inbound_job",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Master Code",
    dataField: "master_code",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Vehicle Name",
    dataField: "vehicle_name",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "UOM",
    dataField: "vehicle_uom",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Model Code",
    dataField: "model_code",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Model Name",
    dataField: "model_name",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Model Year",
    dataField: "model_year",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Color Code",
    dataField: "color_code",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Color Name",
    dataField: "color_name",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Production Date",
    dataField: "production_date",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    formatter: (e) => {
      if (e === null) {
        return "";
      }
      if (e === "") {
        return "";
      } else {
        return moment(e).format(date);
      }
    },

    style: { minWidth: "160px" },
  },
  {
    text: "Engine No.",
    dataField: "engine_no",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },

  {
    text: "Key No.",
    dataField: "key_no",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Mileage",
    dataField: "mileage",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Accessories Installed",
    dataField: "accessories_installed",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
    formatter: formatterStatus,
  },
  {
    text: "Accessories Installed Date ",
    dataField: "accessories_installed_date",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    formatter: (e) => {
      if (e === null) {
        return "";
      }
      if (e === "") {
        return "";
      } else {
        return moment(e).format(date);
      }
    },

    style: { minWidth: "160px" },
  },
  {
    text: "Location",
    dataField: "location",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Parent Location",
    dataField: "parent_location",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Hold Status",
    dataField: "hold_status",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
    formatter: formatterHold,
  },
  {
    text: "Hold Reason",
    dataField: "hold_reason",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Hold Remarks",
    dataField: "hold_reason_remarks",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "RCI Date",
    dataField: "rci_date",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    formatter: (e) => {
      if (e === null) {
        return "";
      }
      if (e === "") {
        return "";
      } else {
        return moment(e).format(date);
      }
    },

    style: { minWidth: "160px" },
  },
  {
    text: "RCI Inspection Result",
    dataField: "rci_inspection_result",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "RCI Remarks",
    dataField: "rci_remarks",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "PDI Date",
    dataField: "pdi_date",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    formatter: (e) => {
      if (e === null) {
        return "";
      }
      if (e === "") {
        return "";
      } else {
        return moment(e).format(date);
      }
    },

    style: { minWidth: "160px" },
  },
  {
    text: "PDI Results",
    dataField: "pdi_inspection_result",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "PDI Remarks",
    dataField: "pdi_remarks",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Maintenance Date",
    dataField: "maintenance_date",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    formatter: (e) => {
      if (e === null) {
        return "";
      }
      if (e === "") {
        return "";
      } else {
        return moment(e).format(date);
      }
    },
    style: { minWidth: "160px" },
  },
  {
    text: "Maintenance Hold Status",
    dataField: "maintenance_hold_status",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
    formatter: formatterHold,
  },
  {
    text: "Maintenance Hold Reason",
    dataField: "maintenance_hold_reason",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Maintenance Hold Remarks",
    dataField: "maintenance_hold_remarks",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Inspection Date",
    dataField: "inspection_date",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    formatter: (e) => {
      if (e === null) {
        return "";
      }
      if (e === "") {
        return "";
      } else {
        return moment(e).format(date);
      }
    },

    style: { minWidth: "160px" },
  },
  // {
  //   text: "Inspection Hold Status",
  //   dataField: "inspection_hold",
  //   sort: true,
  //   sortCaret: sortCaret,
  //   headerSortingClasses,
  //   style: { minWidth: "160px" },
  //   formatter: formatterHold,
  // },
  // {
  //   text: "Inspection Hold Reason",
  //   dataField: "inspection_hold_reason",
  //   sort: true,
  //   sortCaret: sortCaret,
  //   headerSortingClasses,
  //   style: { minWidth: "160px" },
  // },
  {
    text: "Inspection Remarks",
    dataField: "inspection_remarks",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Final Hold Status",
    dataField: "final_hold_status",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Vehicle Status",
    dataField: "vehicle_status",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "RFS",
    dataField: "rfs",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    formatter: formatterStatus,
  },
  {
    text: "Client",
    dataField: "client",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
  {
    text: "Inventory No.",
    dataField: "inventory_no",
    sort: true,
    sortCaret: sortCaret,
    headerSortingClasses,
    style: { minWidth: "160px" },
  },
];
